"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APSelect = require("../../../../common/APSelect");
var _APButton = _interopRequireDefault(require("../../../../common/APButton"));
var _ContentWithFooterLayoutTemplate = _interopRequireDefault(require("../../../../common/LayoutTemplates/ContentWithFooterLayoutTemplate/ContentWithFooterLayoutTemplate"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _ChartEnums = require("./ChartEnums");
require("./ThemeFormComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('theme-form');
var ThemeFormEditable = function ThemeFormEditable(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  var initialValues = props.initialValues,
    onSubmit = props.onSubmit,
    _props$themeOptions = props.themeOptions,
    themeOptions = _props$themeOptions === void 0 ? [{
      value: 'dark',
      label: t('Dark')
    }, {
      value: 'light',
      label: t('Light')
    }] : _props$themeOptions;
  var _useState = (0, _react.useState)(initialValues === null || initialValues === void 0 ? void 0 : initialValues.theme),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  var _useState3 = (0, _react.useState)(initialValues === null || initialValues === void 0 ? void 0 : initialValues.chart),
    _useState4 = _slicedToArray(_useState3, 2),
    chart = _useState4[0],
    setChart = _useState4[1];
  var chartOptions = (0, _react.useMemo)(function () {
    return Object.keys(_ChartEnums.chartEnums).map(function (key) {
      return {
        value: key,
        label: t(_ChartEnums.chartEnums[key])
      };
    });
  }, [t]);
  var footer = /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: baseClasses(),
    onClick: function onClick() {
      return onSubmit({
        theme: theme,
        chart: chart
      });
    }
  }, t('Update'));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_ContentWithFooterLayoutTemplate["default"], {
    footer: footer,
    customClass: "retail-region-editable-cwf-lt"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('input-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_APSelect.InnerSelect, {
    input: {
      value: theme,
      onChange: function onChange(e) {
        return setTheme(e.target.value);
      }
    },
    name: "theme",
    label: t('Color Theme'),
    customClass: baseClasses(),
    options: themeOptions
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('input-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_APSelect.InnerSelect, {
    input: {
      value: chart,
      onChange: function onChange(e) {
        return setChart(e.target.value);
      }
    },
    name: "chart",
    label: t('Trading Layout Chart'),
    customClass: baseClasses(),
    options: chartOptions
  }))));
};
ThemeFormEditable.propTypes = {
  themeOptions: _propTypes["default"].array,
  initialValues: _propTypes["default"].shape({
    theme: _propTypes["default"].string,
    chart: _propTypes["default"].string
  }),
  onSubmit: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ThemeFormEditable;